import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import { clearCart } from "../../redux/action";
import { useTableSessionEvent } from "../../component/TableSessionProvider";

const OrderSuccessPage = () => {
  const { restaurant, id, table, status } = useParams();
  const redirectTo = useSelector((state) => state.redirectTo);
  const [orderId, setOrderId] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const getNextOrderId = () => {
    const lastOrderId = Number(localStorage.getItem("DISPLAY_ORDER_ID")) || 0;
    const nextOrderId = lastOrderId + 1;

    localStorage.setItem("DISPLAY_ORDER_ID", nextOrderId);

    return String(nextOrderId).padStart(3, "0");
  };

  useEffect(() => {
    const id = getNextOrderId();
    setOrderId(id);

    dispatch(clearCart());
    dispatch({ type: "CLEAR_REDIRECT" });
  }, []);

  useTableSessionEvent("ReceiveBillStatus", data => {
    // Match the existing saga response for every bill status on this page.
    localStorage.removeItem("allInfo");
    window.location.href = `/${restaurant}/${id}/${table}/PaymentStatus/${data.status}`;
  });

  // useEffect(() => {

  //   console.log("redirectTo",redirectTo)
  //   if (!redirectTo) return;

  //   const id = getNextOrderId();
  //   setOrderId(id);

  //    if (redirectTo === "MENU") {
  //      dispatch(clearCart());
  //     navigate(`/${restaurant}/${id}/${table}/menu`);
  //   } dispatch({ type: "CLEAR_REDIRECT" }); // reset redirect
  // }, [redirectTo]);

  // dummy values, replace with your real values
  // const orderId = "#627778";
  const total = "$24.18";

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <div style={styles.iconWrapper}>
          <div style={styles.successIcon}>✓</div>
        </div>

        <h2 style={styles.title}>
          Order Placed
          <br />
          Successfully!
        </h2>

        <p style={styles.subtitle}>Your order has been sent to the kitchen.</p>

        <div style={styles.infoBox}>
          <div style={styles.row}>
            <span>Order ID:</span>
            <span style={{ ...styles.bold, color: "#627778" }}>#{orderId}</span>
          </div>

          {/* <div style={styles.row}>
            <span>Total:</span>
            <span style={{ ...styles.bold, color: "#E76A24" }}>{total}</span>
          </div> */}
        </div>

        <button
          className="btn"
          style={styles.primaryBtn}
          onClick={() => navigate(`/${restaurant}/${id}/${table}/menu`)}
        >
          Order More Items
        </button>

        <button
          style={styles.secondaryBtn}
          onClick={() => navigate(`/${restaurant}/${id}/${table}/reorder`)}
        >
          View Order History
        </button>
      </div>
    </div>
  );
};

const styles = {
  page: {
    width: "100%",
    minHeight: "100vh",
    background: "#F6F6F6",
    display: "flex",
    justifyContent: "center",
    paddingTop: "40px",
  },
  card: {
    width: "90%",
    maxWidth: "420px",
    background: "white",
    borderRadius: "20px",
    padding: "25px",
    boxShadow: "0px 4px 20px rgba(0,0,0,0.1)",
    textAlign: "center",
  },
  iconWrapper: {
    display: "flex",
    justifyContent: "center",
  },
  successIcon: {
    height: "65px",
    width: "65px",
    borderRadius: "50%",
    background: "#D5F5D5",
    color: "#2EB82E",
    fontSize: "38px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontWeight: "bold",
  },
  title: {
    marginTop: "20px",
    fontSize: "26px",
    fontWeight: "700",
    lineHeight: "32px",
  },
  subtitle: {
    marginTop: "10px",
    fontSize: "16px",
    color: "#666",
  },
  infoBox: {
    marginTop: "20px",
    padding: "15px",
    background: "#F7F7F7",
    borderRadius: "12px",
  },
  row: {
    display: "flex",
    justifyContent: "space-between",
    padding: "8px 0",
    fontSize: "16px",
  },
  bold: {
    fontWeight: "600",
  },
  primaryBtn: {
    marginTop: "25px",
    width: "100%",
    padding: "10px",
    color: "white",
    border: "none",
    borderRadius: "10px",
    fontSize: "18px",
    cursor: "pointer",
  },
  secondaryBtn: {
    marginTop: "12px",
    width: "100%",
    padding: "10px",
    background: "#EAEAEA",
    color: "#484646",
    border: "none",
    borderRadius: "10px",
    fontSize: "18px",
    cursor: "pointer",
  },
};

export default OrderSuccessPage;
